import {LinearChart} from "./LinearChart";
import {TaskSearch} from "./taskSearch.model";

export class TaskChart {
  constructor(

    public taskChartDateFrom?: any,
    public taskChartDateTo ?: any,
    public todayDate ?: any,

    public taskCounty ?: String,

    public pendingTaskChart ?: LinearChart[],
    public upcomingTaskChart ?: LinearChart[],
    public overdueTaskChart ?: LinearChart[],

    /*********** Task ***************/
    public pendingTaskSearch  ?: TaskSearch,
    public upcomingTaskSearch ?: TaskSearch,
    public overdueTaskSearch  ?: TaskSearch,

    public taskChartXData ?: any[],
    public overdueTaskChartYData ?: any[],
    public pendingTaskChartYData ?: any[],
    public upcomingTaskChartYData ?: any[]
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/TaskChart.ts